import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  NextApproverChoice,
  type NextApproverChoiceConstructor,
} from './NextApproverChoice'

export const NextApproverChoiceConstructorFactory =
  Factory.Sync.makeFactory<NextApproverChoiceConstructor>({
    id: Factory.each(() => faker.random.number()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    levelText: null,
    approvalDelegatee: null,
  })

export const NextApproverChoiceFactory = EntityFactory(
  NextApproverChoice,
  NextApproverChoiceConstructorFactory
)
